import { dotToComma, roundToXDecimals } from '../../utils/FormatUtils'
import { Recipe } from '../../types/fam-graphql'

export const nutritionalValuesTransformer = (
  recipe: Recipe | null,
  t: any
) => ({
  energeticValueText: t('recipe_nutritional_panel_energy_values'),
  energeticValueKcal: `${roundToXDecimals(
    recipe?.kcal_per_100_g ?? 0,
    0
  )} Kcal`,
  energeticValueKj: `${roundToXDecimals(recipe?.kj_per_100_g ?? 0, 0)} Kj`,
  nutritionalValues: [
    {
      name: t('recipe_nutritional_panel_fat'),
      quantity: `${dotToComma(
        roundToXDecimals(recipe?.lipids_per_100_g ?? 0, 1)
      )} g`,
      includingName: t('recipe_nutritional_panel_saturated_fatty_acids'),
      includingQuantity: `${dotToComma(
        roundToXDecimals(recipe?.saturated_fatty_acids_per_100_g ?? 0, 1)
      )} g`,
    },
    {
      name: t('recipe_nutritional_panel_carbohydrates'),
      quantity: `${dotToComma(
        roundToXDecimals(recipe?.carbohydrates_per_100_g ?? 0, 1)
      )} g`,
      includingName: t('recipe_nutritional_panel_simple_sugars'),
      includingQuantity: `${dotToComma(
        roundToXDecimals(recipe?.simple_sugars_per_100_g ?? 0, 1)
      )} g`,
    },
    {
      name: t('recipe_nutritional_panel_fibres'),
      quantity: `${dotToComma(
        roundToXDecimals(recipe?.fibres_per_100_g ?? 0, 1)
      )} g`,
    },
    {
      name: t('recipe_nutritional_panel_salt'),
      quantity: `${dotToComma(
        roundToXDecimals(recipe?.salt_per_100_g ?? 0, 1)
      )} g`,
    },
    {
      name: t('recipe_nutritional_panel_fruits_and_vegetables'),
      quantity: `${roundToXDecimals(
        (recipe?.pnns_fruit_per_100_g ?? 0) +
          (recipe?.pnns_vegetable_per_100_g ?? 0) ?? 0,
        0
      )} g`,
    },
    {
      name: t('recipe_nutritional_panel_dried_vegetables'),
      quantity: `${roundToXDecimals(
        recipe?.pnns_dried_vegetable_per_100_g ?? 0,
        0
      )} g`,
    },
    {
      name: t('recipe_nutritional_panel_proteins'),
      quantity: `${dotToComma(
        roundToXDecimals(recipe?.proteins_per_100_g ?? 0, 1)
      )} g`,
    },
  ],
})
